export default __webpack_public_path__ + "static/media/crown-second.fbc05621.svg";